export default "__VITE_ASSET__gXJDgk5p__"